import {useState} from 'react';
import {useHistory} from "react-router-dom";
import styled from 'styled-components';
import { FiVideo,FiHash } from "react-icons/fi";

const MainFormContainer = styled.div`
    display: flex;
`;

const NewMeetingButton = styled.button`
    background: ${(props) => props.theme.backgroundColors.default};
    border: none;
    outline: none;
    height: 48px;
    width: 140px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    color: #fff;
    font-size: 15px;
    font-weight: ${(props) => props.theme.font.weight.default};
    cursor: pointer;
    border-radius: 5px;
    margin-right: 10px;
`;

const InnerForm = styled.div`
    display: flex;
    position: relative;
`;

const FormInput = styled.input`
    border: 1px solid ${(props) => props.theme.border.default};
    border-radius: 5px;
    padding: 0 12px 0 42px;
`;

const JoinButton = styled.button`
    background: none;
    border: none;
    outline: none;
    font-weight: ${(props) => props.theme.font.weight.bold};
    cursor: pointer;
`;

const FloatingHash = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    display: flex;
    align-items: center;
    width: 40px;
    color: #757575;
    justify-content: center;
    border-radius: 5px;
`;

const MainForm = (props) => {
    const history = useHistory();
    const [isFocused,setIsFocused] = useState(false);
    const [input,setInput] = useState('');
    const redirectHandler = (e) => {
        const linkExplode = input.split("/");
        const roomId = linkExplode[linkExplode.length - 1];
        history.push(`/room/${roomId}`);
    }
    return (
        <MainFormContainer>
            <NewMeetingButton onClick={() => history.push(`/create-room`)}>
                <FiVideo/> নতুন মিটিংরুম
            </NewMeetingButton>
            <InnerForm>
                <FloatingHash><FiHash/></FloatingHash>
                <FormInput 
                    placeholder="মিটিং লিংক দিন" 
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => input === '' && setIsFocused(false)}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                />
                {isFocused && <JoinButton disabled={input === ''} onClick={redirectHandler}>যুক্ত হন</JoinButton>}
            </InnerForm>
        </MainFormContainer>
    )
}

export default MainForm;